import React from 'react';
import { ImageCouldFromRemoteServer as Image } from '@/components/images'
import { useRouter } from '@/navigation';
import { useTranslations } from 'next-intl';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { KafkaNote } from '@nf/utils-common/constants';

interface SportEventSliderProps {
    onClose: (noSetKafka: boolean) => void;
}

export const SportEventSlider: React.FC<SportEventSliderProps> = ({
	onClose,
}) => {
	const router = useRouter();
	const t = useTranslations('General');
	const { SiteConfigsData } = useGetSiteConfigs();
	return (
		<div className="sport-event-modal">
			<Image
				src="/images/sport-event/sport-event-promo.png"
				alt=""
				width="288"
				height="360"
				className="sport-event-modal__bg"
				isGalaxyFolder={true}
			/>
			<div className="sport-event-modal__content">
				<div className="sport-event-modal__title">
					{t('lbl_KRPopup01')}
				</div>
				<div className="sport-event-modal__desc">
					{t('lbl_KRPopup02')}
				</div>
				{SiteConfigsData?.EnableSportEvent && (
					<button 
						className="sport-event-modal__predict-btn" 
						onClick={() => {
							setKafkaNormal({
								note: KafkaNote.KingBack,
								type: 1,
								action: 1
							});
							router.push('/section/sport-event')
							onClose(true)
						}}
					>
						{t('lbl_KRPopupBtn')}
					</button>
				)}
			</div>
		</div>
	);
};